import dayjs from 'dayjs';
import { expressPointsNames } from './constants';

export const isExpressDeliveryHeading = ({
  isExpressSelected,
  hasAddress
}: {
  isExpressSelected: boolean;
  hasAddress: boolean;
}): boolean => isExpressSelected && hasAddress;

// Only `type` and `nearestAvailableInterval` are read, so accept any store-like
// shape (StoreItem, PickupPoint, etc.) rather than the strict StoreItem type.
type DeliveryTitleInput = {
  type?: string | null;
  nearestAvailableInterval?: {
    value?: string | null;
    nearestIntervalTitle?: string | null;
  } | null;
};

export const createDeliveryTitle = (item: DeliveryTitleInput): string => {
  if (item.type && expressPointsNames.includes(item.type)) {
    return 'Забрать сейчас';
  }

  const date = item?.nearestAvailableInterval?.value;
  const time = item?.nearestAvailableInterval?.nearestIntervalTitle;

  const now = dayjs();
  const today = +now.format('D');
  const tomorrow = +now.add(1, 'day').format('D');
  const deliveryDate = +dayjs(date).format('D');
  const updatedTime = time?.slice(0, 5);
  if (today === deliveryDate) {
    return `сегодня c ${updatedTime}`;
  } else if (tomorrow === deliveryDate) {
    return `завтра c ${updatedTime}`;
  } else {
    return `${dayjs(date).format('DD MMMM')} c ${updatedTime}`;
  }
};
